import { SoulAnalytics } from './SoulAnalytics';

function hasGtm() {
  return typeof window !== 'undefined' && typeof window.dataLayer !== 'undefined';
}

function pushDataLayer(payload) {
  if (typeof window === 'undefined') return;
  try {
    window.dataLayer = window.dataLayer || [];
  } catch (e) {}
  if (!hasGtm()) return;

  // Hook'lanan dataLayer.push çift track etmesin diye işaretliyoruz
  window.dataLayer.push({ ecommerce: null, __soul_internal: true });
  window.dataLayer.push({ ...(payload || {}), __soul_internal: true });
}

function safePrice(val, decimals) {
  return SoulAnalytics.safePrice(val, decimals == null ? 2 : decimals);
}

function normalizeProductCode(val) {
  return SoulAnalytics.normalizeProductCode(val);
}

function trackEvent(event) {
  pushDataLayer({
    event: event.eventName,
    ...event,
  });

  return SoulAnalytics.track(event);
}

function hookDataLayerToSoulAnalytics() {
  if (typeof window === 'undefined') return;
  if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
  if (window._soul_datalayer_hooked) return;
  window._soul_datalayer_hooked = true;

  const originalPush = window.dataLayer.push.bind(window.dataLayer);

  function normalizeEventForBackend(evt) {
    if (!evt || typeof evt !== 'object') return null;
    if (evt.__soul_internal) return null;

    const out = { ...evt };
    if (typeof out.event === 'string' && out.eventName == null) {
      out.eventName = out.event;
    }
    if (out.page != null && out.eventName == null) {
      out.eventName = 'page_view';
    }
    if ((out.event === 'gtm.linkClick' || out.eventName === 'gtm.linkClick') && out['gtm.elementText'] != null && out.linkText == null) {
      out.linkText = out['gtm.elementText'];
    }
    if ((out.event === 'gtm.linkClick' || out.eventName === 'gtm.linkClick') && out['gtm.elementUrl'] != null && out.linkUrl == null) {
      out.linkUrl = out['gtm.elementUrl'];
    }
    return out.eventName ? out : null;
  }

  window.dataLayer.push = function(...args) {
    try {
      args.forEach((arg) => {
        const normalized = normalizeEventForBackend(arg);
        if (normalized) {
          SoulAnalytics.track(normalized).catch(() => null);
        }
      });
    } catch (e) {
      // best-effort
    }
    return originalPush(...args);
  };
}

function initAutoLinkClickTracking() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window._soul_link_tracking_init) return;
  window._soul_link_tracking_init = true;

  document.addEventListener('click', function(e) {
    try {
      // Eğer bir handler (React Router Link, footer/menu click vb.) preventDefault yaptıysa
      // auto link click tracking ile duplicate event göndermeyelim.
      if (e && e.defaultPrevented) return;

      const target = e.target;
      if (!target) return;
      const a = target.closest ? target.closest('a') : null;
      if (!a) return;

      const href = a.getAttribute('href') || '';
      if (!href || href === '#' || href.startsWith('javascript:')) return;
      if (href.startsWith('mailto:') || href.startsWith('tel:')) return;

      const text = (a.textContent || '').trim().slice(0, 200);
      const url = a.href || href;

      if (typeof window.soulTrackEvent === 'function') {
        window.soulTrackEvent({
          eventName: 'gtm.linkClick',
          linkText: text,
          linkUrl: url,
          'gtm.elementText': text,
          'gtm.elementUrl': url,
        });
      }
    } catch (err) {
      // best-effort
    }
  }, false);
}

export function initSoulDataLayerBridge() {
  try {
    const lat = sessionStorage.getItem('_soul_latitude');
    const lng = sessionStorage.getItem('_soul_longitude');
    if (lat != null && lat !== '' && lng != null && lng !== '') {
      window.latitude = lat;
      window.longitude = lng;
    }
  } catch (e) {
    // no-op
  }

  // Opsiyonel: dışarıdan (component'lerden) kolay erişim
  window.SoulAnalytics = SoulAnalytics;

  window.safePrice = safePrice;
  window.normalizeProductCode = normalizeProductCode;
  window.soulTrackEvent = trackEvent;

  window.gtmUserLogin = function(isLogin = false, userId = 'error', eventCallback = null) {
    const req = trackEvent({
      eventName: 'login',
      login_type: isLogin ? 'success' : 'error',
      cd_user_id: isLogin ? String(userId) : 'error',
    });
    if (typeof eventCallback === 'function') {
      eventCallback();
    }
    return req;
  };

  window.gtmUserRegister = function(isRegister = false, userId = 'error', eventCallback = null) {
    const req = trackEvent({
      eventName: 'sign_up',
      signup_type: isRegister ? 'success' : 'error',
      cd_user_id: isRegister ? String(userId) : 'error',
    });
    if (typeof eventCallback === 'function') {
      eventCallback();
    }
    return req;
  };

  window.soulTrackPageView = function() {
    return SoulAnalytics.track({
      eventName: 'page_view',
      category_type: window.location.pathname,
      source_path: document.referrer || '',
    }).catch(() => null);
  };

  hookDataLayerToSoulAnalytics();
  initAutoLinkClickTracking();
}

export default initSoulDataLayerBridge;
